import {
  DEFINITE_SCOPE,
  CONVERTIBLE_SCOPE,
  IMPORTED_SCOPE,
  INDEFINITE_SCOPE,
} from "../../global/constants";
import { LIBRARY_CSV_IMPORT } from "../../licenseData";
import { allowFeature } from "../FeatureUtils.js/FeatureUtils";

// Structural sharing matters here: the Assumptions panel of the generative
// workspace derives a whole tree from this list, and every holder that comes
// back with a new identity re-runs that derivation. Only the holder carrying
// the edited quantity may be rebuilt.
export default function updateQuantities(quantitiesList, actions) {
  const updatedId = actions.payload?.id;
  let changed = false;
  const updatedQuantities = quantitiesList.map((scope) => {
    const index = scope.quantities.findIndex((item) => item.id === updatedId);
    if (index < 0) {
      return scope;
    }
    changed = true;
    const tmpQuantities = scope.quantities.slice();
    tmpQuantities[index] = actions.payload;
    return {
      ...scope,
      quantities: tmpQuantities,
    };
  });
  return changed ? updatedQuantities : quantitiesList;
}

export const getStructureTypesForTenant = () => {
  const structureTypes = [
    { value: INDEFINITE_SCOPE, displayValue: INDEFINITE_SCOPE },
    { value: DEFINITE_SCOPE, displayValue: DEFINITE_SCOPE },
    { value: CONVERTIBLE_SCOPE, displayValue: CONVERTIBLE_SCOPE },
  ];

  if (allowFeature(LIBRARY_CSV_IMPORT)) {
    structureTypes.push({
      value: IMPORTED_SCOPE,
      displayValue: IMPORTED_SCOPE,
    });
  }

  return structureTypes;
};
